import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PandoraBrandLogo = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="Calque_2"
        viewBox="0 0 563.61 109.23"
        style={{ width: '5.2em' }}
      >
        <defs>
          <style>
            {`.cls-1 {
              fill: url(#Dégradé_sans_nom_39);
            }
            .cls-2 {
              fill: url(#Dégradé_sans_nom_37);
            }
            .cls-3 {
              fill: #ffff;
            }

            .cls-4 {
              fill: #1a1a1c;
            }

            .cls-5 {
              opacity: .1;
            }

            .cls-6 {
              fill: url(#Dégradé_sans_nom_40);
            }

            .cls-7 {
              fill: url(#Dégradé_sans_nom_38);
            }`}
          </style>
          <linearGradient
            id="Dégradé_sans_nom_37"
            data-name="Dégradé sans nom 37"
            x1="17.43"
            y1="21.48"
            x2="44.1"
            y2="43.34"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".28" stopColor="#fc2e25" />
            <stop offset="1" stopColor="#bd241c" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_39"
            data-name="Dégradé sans nom 39"
            x1="47.95"
            y1="61.72"
            x2="74.64"
            y2="83.6"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".28" stopColor="#00a849" />
            <stop offset="1" stopColor="#00692d" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_40"
            data-name="Dégradé sans nom 40"
            x1="81.26"
            y1="17.31"
            x2="48.61"
            y2="49.96"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".33" stopColor="#ffb600" />
            <stop offset="1" stopColor="#bf8900" />
          </linearGradient>
          <linearGradient
            id="Dégradé_sans_nom_38"
            data-name="Dégradé sans nom 38"
            x1="27.86"
            y1="79.94"
            x2="43.04"
            y2="64.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".1" stopColor="#2785fa" />
            <stop offset="1" stopColor="#1e64ba" />
          </linearGradient>
        </defs>
        <g id="Logotype">
          <g>
            <g>
              <path
                className="cls-3"
                d="M168.33,52.2c-1.61,2.98-4.13,5.37-7.56,7.2-3.43,1.82-7.75,2.73-12.97,2.73h-10.66v24.4h-12.75V22.98h23.4c4.92,0,9.1.85,12.56,2.55s6.05,4.04,7.79,7.01c1.73,2.97,2.59,6.34,2.59,10.1,0,3.4-.81,6.59-2.41,9.56ZM155.08,49.43c1.7-1.61,2.55-3.87,2.55-6.78,0-6.19-3.46-9.29-10.38-9.29h-10.11v18.48h10.11c3.52,0,6.13-.81,7.82-2.41Z"
              />
              <path
                className="cls-3"
                d="M218.72,74.42h-25.31l-4.19,12.11h-13.38l22.85-63.64h14.84l22.85,63.64h-13.48l-4.19-12.11ZM215.26,64.23l-9.2-26.59-9.2,26.59h18.39Z"
              />
              <path
                className="cls-3"
                d="M299.3,86.53h-12.75l-28.87-43.61v43.61h-12.75V22.89h12.75l28.87,43.7V22.89h12.75v63.64Z"
              />
              <path
                className="cls-3"
                d="M351.7,26.89c5.07,2.61,8.99,6.33,11.75,11.15,2.76,4.83,4.14,10.43,4.14,16.8s-1.38,11.95-4.14,16.71c-2.76,4.76-6.68,8.45-11.75,11.06-5.07,2.61-10.94,3.91-17.62,3.91h-22.22V22.98h22.22c6.67,0,12.55,1.31,17.62,3.92ZM349.11,70.23c3.64-3.65,5.46-8.77,5.46-15.39s-1.82-11.79-5.46-15.52c-3.65-3.73-8.8-5.6-15.48-5.6h-9.01v41.97h9.01c6.68,0,11.84-1.82,15.48-5.46Z"
              />
              <path
                className="cls-3"
                d="M390.26,82.98c-4.98-2.79-8.92-6.66-11.84-11.61s-4.37-10.54-4.37-16.8,1.45-11.76,4.37-16.71c2.92-4.94,6.86-8.82,11.84-11.6,4.97-2.79,10.43-4.19,16.39-4.19s11.49,1.4,16.44,4.19c4.95,2.79,8.86,6.66,11.74,11.6,2.88,4.95,4.33,10.52,4.33,16.71s-1.44,11.85-4.33,16.8c-2.88,4.95-6.81,8.82-11.79,11.61-4.98,2.79-10.44,4.19-16.39,4.19s-11.41-1.39-16.39-4.19ZM416.75,73.19c2.92-1.73,5.19-4.2,6.83-7.42,1.64-3.21,2.46-6.95,2.46-11.2s-.82-7.96-2.46-11.15c-1.64-3.19-3.92-5.63-6.83-7.33-2.91-1.7-6.28-2.55-10.1-2.55s-7.21.85-10.15,2.55c-2.95,1.7-5.24,4.14-6.88,7.33-1.64,3.19-2.46,6.9-2.46,11.15s.82,7.98,2.46,11.2c1.64,3.22,3.93,5.69,6.88,7.42,2.94,1.73,6.33,2.59,10.15,2.59s7.2-.86,10.1-2.59Z"
              />
              <path
                className="cls-3"
                d="M481.4,86.53l-14.02-24.76h-6.01v24.76h-12.75V22.98h23.85c4.92,0,9.11.87,12.57,2.6,3.45,1.73,6.05,4.06,7.78,7.01,1.73,2.95,2.6,6.24,2.6,9.88,0,4.19-1.21,7.97-3.65,11.34-2.43,3.37-6.04,5.69-10.83,6.97l15.21,25.77h-14.75ZM461.37,52.2h10.66c3.45,0,6.03-.83,7.74-2.5,1.7-1.67,2.55-3.99,2.55-6.97s-.85-5.17-2.55-6.78c-1.7-1.61-4.28-2.41-7.74-2.41h-10.66v18.67Z"
              />
              <path
                className="cls-3"
                d="M545.95,74.42h-25.31l-4.19,12.11h-13.38l22.85-63.64h14.84l22.85,63.64h-13.48l-4.19-12.11ZM542.49,64.23l-9.2-26.59-9.2,26.59h18.39Z"
              />
            </g>
            <g>
              <g>
                <g>
                  <polygon
                    className="cls-2"
                    points="46.16 0 46.16 41.71 35.67 41.71 35.67 52.21 0 52.21 46.16 0"
                  />
                  <polygon
                    className="cls-1"
                    points="97.16 57.02 50.97 109.23 50.97 67.53 61.49 67.53 61.49 57.02 97.16 57.02"
                  />
                  <polygon
                    className="cls-6"
                    points="83.92 52.21 61.49 52.21 61.49 41.71 50.97 41.71 50.97 10.04 83.92 52.21"
                  />
                  <polygon
                    className="cls-7"
                    points="46.16 67.53 46.16 99.21 13.21 57 35.67 57 35.67 67.53 46.16 67.53"
                  />
                </g>
                <g className="cls-5">
                  <polygon
                    className="cls-4"
                    points="46.16 9.73 46.16 41.71 35.67 41.71 35.67 52.21 8.59 52.21 46.16 9.73"
                  />
                  <polygon
                    className="cls-4"
                    points="88.55 57.02 50.97 99.5 50.97 67.53 61.49 67.53 61.49 57.02 88.55 57.02"
                  />
                  <polygon
                    className="cls-4"
                    points="61.49 52.21 61.49 41.71 50.97 41.71 50.97 18.12 77.61 52.21 61.49 52.21"
                  />
                  <polygon
                    className="cls-4"
                    points="46.16 67.53 46.16 91.12 19.51 57 35.67 57 35.67 67.53 46.16 67.53"
                  />
                </g>
              </g>
              <polygon
                className="cls-3"
                points="52.94 47.61 44.22 47.61 41.57 47.61 41.57 50.25 41.57 58.98 41.57 61.63 44.22 61.63 52.94 61.63 55.59 61.63 55.59 58.98 55.59 50.25 55.59 47.61 52.94 47.61"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default PandoraBrandLogo;
